import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  HeadingText,
  BodyText,
  HorizontalScroll,
} from '@paypalcorp/pp-react';
import styles from './styles.less';
import { GivingZoneCarousel } from '@paypalcorp/giving-fundraising';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import * as analytics from '../../lib/analytics';

const PromoMessageCarousel = (props) => {
  const {
    tileType,
    featuredImageUrl,
    backgroundColor,
    isFeatureImageToTheLeft,
    hasImageOffset,
    fontColor,
    cardContent,
    header,
    subHeader,
    order,
    openNewTab,
    domain,
    isLoading,
    authState,
    contentCountry,
    onTileLoad,
    onTileShow,
    onLoad,
    onShow,
    carouselType,
  } = props;

  const imageComponent = (
    <Col
      key='imageComponent'
      sm={6}
      xs={12}
      className={`${styles.imageFeaturedColumn}`}
    >
      <div
        className={` ${styles.featuredImage}  ${
          hasImageOffset ? styles.featuredImage__offset : ''
        }`}
        style={{
          backgroundImage: `url(${featuredImageUrl}) `,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100%',
        }}
      ></div>
    </Col>
  );

  const carouselComponent = (numOfVisibleItems) => {
    return (
      cardContent &&
      cardContent.length > 0 && (
        <div
          onClick={(event) =>
            analytics.onTileClick(event, {
              contentCountry,
              authState: authState === 'ANONYMOUS' ? 'guest' : 'member',
              order,
            })
          }
        >
          <GivingZoneCarousel
            showLink={false}
            linkText={''}
            numOfVisibleItems={numOfVisibleItems}
            cardContent={cardContent}
            title=''
            openNewTab={openNewTab}
            domain={domain}
            type={tileType}
            isLoading={isLoading}
            onTileShow={(index) => {
              onTileShow(index, cardContent, numOfVisibleItems, order);
            }}
            onTileLoad={(data) => onTileLoad(data, order)}
            onLoad={() => onLoad(tileType, carouselType)}
            onShow={() => onShow(tileType, carouselType)}
          />
        </div>
      )
    );
  };

  const headerComponent = (
    <Col key='headerComponent' sm={6} xs={12}>
      <div className={styles.carouselContainer}>
        <HeadingText style={{ color: fontColor }} size='lg'>
          {header}
        </HeadingText>
        <BodyText
          className={styles.carouselContainerFont}
          style={{ color: fontColor }}
        >
          {subHeader}
        </BodyText>
        <MediaQuery maxWidth={579}>{carouselComponent(2)}</MediaQuery>
        <MediaQuery maxWidth={1023} minWidth={580}>
          {carouselComponent(1)}
        </MediaQuery>
        <MediaQuery minWidth={1024}>{carouselComponent(2)}</MediaQuery>
      </div>
    </Col>
  );

  return (
    <Container
      form={true}
      style={{
        backgroundColor: `${backgroundColor}`,
        padding: `${hasImageOffset ? 0 : '28px 0 28px 0'}`,
        borderRadius: '24px',
      }}
    >
      <Container
        className={`${styles.promoCarrosuselContainer}`}
        style={{ backgroundColor: `${backgroundColor}` }}
      >
        <MediaQuery maxWidth={480}>
          <Row noGutters={true}>{[imageComponent, headerComponent]}</Row>
        </MediaQuery>

        <MediaQuery minWidth={481}>
          <Row noGutters={true}>
            {isFeatureImageToTheLeft
              ? [imageComponent, headerComponent]
              : [headerComponent, imageComponent]}
          </Row>
        </MediaQuery>
      </Container>
    </Container>
  );
};

PromoMessageCarousel.propTypes = {
  featuredImageUrl: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  isFeatureImageToTheLeft: PropTypes.bool,
  hasImageOffset: PropTypes.bool,
  fontColor: PropTypes.string,
  cardContent: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      logoImageUrl: PropTypes.string,
      name: PropTypes.string,
      actions: PropTypes.string,
      campaignImage: PropTypes.string,
      charityName: PropTypes.string,
      participantText: PropTypes.string,
      primaryImageUrl: PropTypes.string,
      campaignTitle: PropTypes.string,
      rangeEndText: PropTypes.string,
      rangeStartText: PropTypes.string,
      totalAmountText: PropTypes.string,
      contributedAmountText: PropTypes.string,
    })
  ).isRequired,
  openNewTab: PropTypes.bool,
  domain: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string.isRequired,
  onTileLoad: PropTypes.func.isRequired,
  onTileShow: PropTypes.func.isRequired,
  onShow: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired,
  tileType: PropTypes.string.isRequired,
  order: PropTypes.number.isRequired,
  carouselType: PropTypes.string.isRequired,
};

PromoMessageCarousel.defaultProps = {
  isFeatureImageToTheLeft: true,
  hasImageOffset: false,
  fontColor: '#FFFFFF',
  isLoading: false,
  openNewTab: true,
};

export { PromoMessageCarousel };
